export class MultiPickingTask {
    public deliveryTaskID: string;
    public orderID: number;
    public providerName: string;
    public calculatedPrice: number;
    public calculatedPriceEnabled: boolean;
    public multipickingTaskIdentifierChar: string;
    public multipickingTaskIdentifierColor: string;
}
